exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-container[data-v-46d14ee5] {\n  position: fixed;\n  z-index: 10;\n}\n", ""]);

// exports
